import { useEffect, useState } from "react";
import { _GenericItem, _ImportRegistry, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DECIMAL, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { PrintJson } from "../../theme/Component/PrintJson"
import { InputMoney } from "../../theme/Input/InputMoney";
import { ImportRegistryItem } from "./ImportRegistryItem";
import { TaxPositionEditor } from "../../bpm/CustomFormNew/CustomForms/Compras/NationalizationProcessGeneralInfo/TaxPosition/TaxPositionEditor";
import { SelectTHConstantsValue } from "../../bpm/config/Componentes/SelectTHConstantsValue";


interface Props {
    formBean: any;
    typeForm: number;
}
export const GenericItem = ({ formBean, typeForm }: Props) => {

    const importRegistry = useDataBean(_ImportRegistry);
    const _genericItems = useDataBean(_GenericItem);
    const { bean, setBean, lista, setLista, instance, handleChange } = _genericItems;

    const modalEdit = useModal("Editar", MODAL_md);
    const modalImportar = useModal("Importar", MODAL_LG);
    const modalDel = useModal("Eliminar", MODAL_SM);

    const [copy, setCopy] = useState<any>([]);

    const [head, setHead] = useState<any>(
        [
            { title: 'Descripción', property: 'Description' },
            { title: 'Cantidad', property: 'Quantity' },
        ]
    )


    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    const getIDForm = () => {
        switch (typeForm) {
            case importRegistry.instance.COSTANALYSIS: return formBean.IDCostAnalysis;//estudio de costos
            case importRegistry.instance.PRODUCTINVENTORY: return formBean.IDProductInventory;// inventario de mercancias
            case importRegistry.instance.SETTLEMENT: return formBean.IDCostSettlement;// liquidacion 
            case importRegistry.instance.IMPORTDECLARATION: return formBean.IDImportDeclaration; //declaracion           
            case importRegistry.instance.HANDOVERCERTIFICATE: return formBean.IDDeliveryCertificate;// Acta de entrega
            default: return 0;
        }
    }

    const addItem = () => {
        setBean(
            {
                IDEmployee: _single.getAccountID(),
                State: 1,
                FormType: typeForm,
                IDFormType: getIDForm(),
            }
        );
        modalEdit.open();
    }
    const edit = () => {

        let tmp1 = addRenderInfoItem(bean);
        setCopy([...lista, tmp1]);

        let tmp = addRenderInfoItem(bean);
        const atributeJson = JSON.stringify(tmp);
        tmp = { ...tmp, AtributesJoson: atributeJson };
        _genericItems.updateCustonBean(tmp).then(
            (resp: any) => {
                getListItems();
                modalEdit.close();
            }
        ).catch((error: any) => {
            console.log(error);
        })
    }
    const addRenderInfoItem = (item: any) => {
        switch (typeForm) {
            case importRegistry.instance.COSTANALYSIS:
                {
                    try {
                        const tasa = parseFloat(formBean.ExchangeRateEC);
                        const comis = parseFloat(formBean.ForpoComission);
                        item.TotalDap = (item.Quantity ?? 0) * (item.VrDapUnt ?? 0);
                        item.TotalPesos = (item.TotalDap ?? 0) * tasa;
                        item.FoporCom = ((item.TotalPesos ?? 0) * comis) / 100;
                        item.Arancel = ((item.TotalPesos ?? 0) * (item.TaxPercentage ?? 0)) / 100;
                        item.TotalEstudio = (parseFloat(item.TotalPesos ?? 0) + parseFloat(item.Arancel ?? 0) + parseFloat(item.FoporCom ?? 0)).toFixed(2);

                    } catch (error) {

                    }

                }
                break;
            case importRegistry.instance.SETTLEMENT:
                {
                    try {

                        let total = 0;
                        copy.forEach(element => {
                            if (element.DataBeanProperties.VrTotalFOB)
                                total += (parseFloat(element.DataBeanProperties.VrTotalFOB ?? 0));
                        });
                        console.log("Total FOB", total);

                        const costo = parseFloat(formBean.OtherCost ?? 0);
                        const tasa = parseFloat(formBean.ExchangeRateLIQ ?? 0);
                        const comision = parseFloat(formBean.ForpoComision ?? 0);
                        item.VrTotalFOB = (item.Quantity ?? 0) * (item.VrFOB ?? 0);
                        item.VrDAPTotal = (item.Quantity ?? 0) * (item.VrDAP ?? 0);
                        item.OtherCost = (item.VrTotalFOB ?? 0) * costo / total;
                        item.VrTotalCIP = (item.VrDAPTotal ?? 0) - (item.OtherCost ?? 0);
                        item.VrDAPPesos = (item.VrDAPTotal ?? 0) * (tasa);
                        item.VrComision = ((item.VrDAPPesos ?? 0) * ((comision)) / 100);
                        item.VrTotalPesos = (item.VrDAPPesos ?? 0) + (item.VrGrabament ?? 0) + (item.VrComision);
                        item.VrFlete = (item.VrTotalCIP ?? 0) - (item.VrTotalFOB ?? 0);


                    } catch (error) {

                    }

                }
                break;
            case importRegistry.instance.HANDOVERCERTIFICATE:
                {
                    try {
                        let tasa = parseFloat(formBean.ExchangeRate ?? 0);

                        if (formBean.DeliveryCertificateType === 101) {
                            item.VrTotalFob = parseFloat(item.VrTotalFob ?? 0);
                            item.VrFlete = parseFloat(formBean.FleteValue ?? 0);
                            item.VrSeguros = 0;
                            item.VrTotalCIF = (item.VrTotalFob ?? 0) + (item.VrFlete ?? 0);
                            item.VrTotalCOP = (item.VrTotalCIF ?? 0) * tasa;
                        } else {
                            let total = 0;
                            let totalFlete = parseFloat(formBean.FleteValue ?? 0);
                            let totalImpuesto = parseFloat(formBean.InsuranceValue ?? 0);
                            copy.forEach(element => {
                                if (element.DataBeanProperties.VrTotalFob)
                                    total += (parseFloat(element.DataBeanProperties.VrTotalFob ?? 0));
                                // totalFlete+=(parseFloat(element.DataBeanProperties.Flete ?? 0));
                            });
                            console.log("Total FOB", total);
                            console.log("Total Flete", totalFlete);
                            console.log("Total Impuesto", totalImpuesto);

                            item.VrTotalFob = (item.Quantity ?? 0) * (item.VrUnitario ?? 0);
                            item.VrFlete = (((item.VrTotalFob ?? 0) * (totalFlete ?? 0))) / (total ?? 0);
                            item.VrSeguros = (((item.VrTotalFob ?? 0) * (totalImpuesto ?? 0))) / (total ?? 0);
                            item.VrTotalCIF = (item.VrTotalFob ?? 0) + (item.VrFlete ?? 0) + (item.VrSeguros ?? 0);
                            item.VrTotalCOP = (item.VrTotalCIF ?? 0) * (tasa ?? 0);

                            console.log("Total Fle", item.VrFlete);
                            console.log("Total Imp", item.VrSeguros);
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
                break;
            case importRegistry.instance.IMPORTDECLARATION:
                {
                    // { title: 'Psicion Arancelaria', property: 'PosicionArancel' },
                    //     { title: 'Unidad Medida', property: 'UnitName' },
                    //     { title: 'Valor FOB', property: 'VrFOB',mask:MASK_DECIMAL },
                    //     { title: 'Flete Y Seguro', property: 'VrFlete',mask:MASK_DECIMAL },
                    //     { title: 'Valor CIF Dolares', property: 'VrCIFDolar',mask:MASK_DECIMAL },
                    //     { title: 'Valor CIF Pesos', property: 'VrCIFPesos',mask:MASK_DECIMAL },                       
                    try {

                        let tasa = parseFloat(formBean.ExchangeRate ?? 0);
                        item.VrCIFDolar = (item.VrFOB ?? 0) + (item.VrFlete ?? 0);
                        item.VrCIFPesos = (item.VrCIFDolar ?? 0) * (tasa ?? 0);

                    } catch (error) {
                        console.error(error);
                    }

                }
                break;

            default:
                break;
        }
        return item;
    }

    const updateCostSettlement = async () => {
        if (!lista || lista.length === 0) {
            toast.warning("No hay elementos para actualizar.");
            return;
        }

        toast.info("Actualizando y recalculando items...");

        try {
            for (let i = 0; i < lista.length; i++) {
                const element = lista[i];
                if (element && element.DataBeanProperties) {
                    let tmp = addRenderInfoItem(element.DataBeanProperties);
                    const atributeJson = JSON.stringify(tmp);
                    tmp = { ...tmp, AtributesJoson: atributeJson };

                    // Esperamos secuencialmente a que termine la actualización
                    await _genericItems.updateCustonBean(tmp);
                }
            }
            toast.success("Items actualizados y recalculados con éxito.");
        } catch (error) {
            console.error("Error actualizando items:", error);
            toast.error("Ocurrió un error al actualizar los items.");
        } finally {
            getListItems();
        }
    }
    const delItem = () => {
        _genericItems.updateCustonBean({ ...bean, State: 2 }).then(
            (resp: any) => {
                getListItems();
                modalDel.close();
            }
        )

    }
    const getIconButtons = () => [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } },
        {
            nombre: 'Recalcular y Actualizar Todo',
            visible: (typeForm === importRegistry.instance.SETTLEMENT || typeForm === importRegistry.instance.HANDOVERCERTIFICATE),
            icono: 'ri-refresh-line',
            evento: () => { updateCostSettlement() }
        }
    ];

    const getListItems = () => {

        const filter = {
            IDFormType: getIDForm(),
            FormType: typeForm,
            State: 1
        }
        _genericItems.getLista(filter, null).then(
            (resp: any) => {

            }).catch((error: any) => {
                console.log(error);
            })

    }
    const addElements = (properties: any) => {
        if (!properties) return properties;
        const json = getJson(properties.AtributesJoson);
        Object.keys(json).forEach((key: string) => {
            if (json[key] != null)
                properties[key] = json[key];
        })
        return properties;
    }
    const getJson = (json: any) => {
        var ret = {};

        try {
            ret = JSON.parse(json);
        } catch (error) {

        }
        return ret;
    }
    const addItemFromList = (item: any) => {
        console.log(item);
        if (item && item.IDImportRegistryItem) {
            setBean(prev => ({
                ...prev,
                Description: item.Description,
                Quantity: item.Quantity,
                LoteNumber: item.LoteNumber
            }));
        }
    }

    const addHeadPropertiess = () => {
        switch (typeForm) {
            case importRegistry.instance.COSTANALYSIS:
                setHead([...head,
                { title: 'Vr Unit Dap', property: 'VrDapUnt', mask: MASK_MONEY },
                { title: 'Vr Total Dap', property: 'TotalDap', mask: MASK_MONEY },
                { title: 'Vr Total Pesos', property: 'TotalPesos', mask: MASK_MONEY },
                { title: '% Arancel', property: 'TaxPercentage', mask: MASK_DECIMAL },
                { title: 'Comision', property: 'FoporCom', mask: MASK_MONEY },
                { title: 'Vr Arancel', property: 'Arancel', mask: MASK_MONEY },
                { title: 'Total Estudio', property: 'TotalEstudio', mask: MASK_MONEY },

                ])
                break;
            case importRegistry.instance.PRODUCTINVENTORY:
                setHead([...head,
                { title: 'No. Parte', property: 'SerialNumber' },
                { title: 'No. Documento', property: 'DocumentNumber' },
                { title: 'Unidad Medida', property: 'UnitName' },
                { title: 'Caso', property: 'Case' },

                ])
                break;
            case importRegistry.instance.SETTLEMENT:
                setHead([...head,
                { title: 'Vr Unit FOB', property: 'VrFOB', mask: MASK_MONEY },
                { title: 'Vr Total FOB', property: 'VrTotalFOB', mask: MASK_MONEY },
                { title: 'Fletes y Seguros', property: 'VrFlete', mask: MASK_MONEY },
                { title: 'Valor Total CIP', property: 'VrTotalCIP', mask: MASK_MONEY },
                { title: 'Otros Costos', property: 'OtherCost', mask: MASK_MONEY },
                { title: 'Valor DAP', property: 'VrDAP', mask: MASK_MONEY },
                { title: 'Valor DAP Total', property: 'VrDAPTotal', mask: MASK_MONEY },
                { title: 'Valor DAP Pesos', property: 'VrDAPPesos', mask: MASK_MONEY },
                { title: 'Valor Gravamenes', property: 'VrGrabament', mask: MASK_MONEY },
                { title: 'Valor Comisión', property: 'VrComision', mask: MASK_MONEY },
                { title: 'Valor Total Pesos', property: 'VrTotalPesos', mask: MASK_MONEY },
                ])
                break;
            case importRegistry.instance.IMPORTDECLARATION:
                setHead([...head,
                { title: 'Posición Arancelaria', property: 'TaxCode' },
                { title: 'Unidad Medida', property: 'UnitName' },
                { title: 'Valor FOB', property: 'VrFOB', mask: MASK_MONEY },
                { title: 'Flete Y Seguro', property: 'VrFlete', mask: MASK_MONEY },
                { title: 'Valor CIF Dolares', property: 'VrCIFDolar', mask: MASK_MONEY },
                { title: 'Valor CIF Pesos', property: 'VrCIFPesos', mask: MASK_MONEY },
                ])
                break;
            case importRegistry.instance.HANDOVERCERTIFICATE:
                setHead([...head,
                ...(formBean.DeliveryCertificateType === 101 ? [
                    { title: 'No. Parte', property: 'ParteNo' },
                    { title: 'No. Serie', property: 'SerieNo' },
                    { title: 'Valor FOB Total', property: 'VrTotalFob', mask: MASK_MONEY },
                    { title: 'Valor Fletes y Seguros', property: 'VrFlete', mask: MASK_MONEY },
                    { title: 'Valor CIF Total', property: 'VrTotalCIF', mask: MASK_MONEY },
                    { title: 'Valor Pesos Total', property: 'VrTotalCOP', mask: MASK_MONEY },
                ] : [
                    { title: 'Unidad Medida', property: 'UnitName' },
                    { title: 'Vr. Unitario', property: 'VrUnitario', mask: MASK_MONEY },
                    { title: 'Vr. Total FOB', property: 'VrTotalFob', mask: MASK_MONEY },
                    { title: 'Flete', property: 'VrFlete', mask: MASK_MONEY },
                    { title: 'Seguros y Gastos', property: 'VrSeguros', mask: MASK_MONEY },
                    { title: 'Vr. Total CIF', property: 'VrTotalCIF', mask: MASK_MONEY },
                    { title: 'Vr. Total COP', property: 'VrTotalCOP', mask: MASK_MONEY },
                ]),
                ])
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        addHeadPropertiess();
    }, [])
    useEffect(() => {

        if (formBean.IDImportRegistry) {
            getListItems();
        }
    }, [formBean])
    useEffect(() => {
        if (lista.length > 0) {

            let changed = false;
            const resp = lista.map((element: any) => {
                if (element.DataBeanProperties && !element.DataBeanProperties._parsed) {
                    const parsedProps = addElements(element.DataBeanProperties);
                    changed = true;
                    return {
                        ...element,
                        DataBeanProperties: {
                            ...parsedProps,
                            _parsed: true
                        }
                    };
                }
                return element;
            });
            if (changed) {
                setLista(resp);
            }
            setCopy([...lista]);
        }
    }, [lista])



    return (
        <div className="row">

            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={getIconButtons()} listButtons={listaBotones()}></BasicTable>
                {/* <PrintJson json={lista}/> */}
                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={edit}>
                    <div className="row">
                        <div className="col-md-8">
                            <ImportRegistryItem editor={true} importRegistry={formBean} onChange={addItemFromList} />
                            <span>(Importar desde los items de la nacionalización)</span>
                            <hr />
                        </div>
                        {(typeForm !== importRegistry.instance.HANDOVERCERTIFICATE || formBean.DeliveryCertificateType !== 101) &&
                            <div className="col-md-6">
                                <label>Lote</label>
                                <input type="text" name="LoteNumber" value={bean.LoteNumber} onChange={handleChange} className="form-control" />
                            </div>
                        }
                        <div className="col-md-6">
                            <label>Cantidad</label>
                            <input type="number" name="Quantity" value={bean.Quantity} onChange={handleChange} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <input type="text" name="Description" value={bean.Description} onChange={handleChange} className="form-control" />
                        </div>
                        {typeForm == importRegistry.instance.COSTANALYSIS &&
                            <>
                                <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.VrDapUnt} onChange={(e) => { setBean(prev => ({ ...prev, VrDapUnt: e })) }} _label="Valor DAP Unitario" />
                                </div>
                                <div className="col-md-6">
                                    <TaxPositionEditor render={bean.TaxCode}
                                        idSelector={bean.IDTaxPosition}
                                        onChange={(e) => { setBean(prev => ({ ...prev, IDTaxPosition: e.IDTaxPosition, TaxCode: e.TaxCode, TaxPercentage: e.TaxPercentage, TaxCodeStr: e.TaxCode + " - " + e.TaxDescription })) }}
                                        label="Posicion Arancelaria"
                                        returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.TaxPercentage ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, TaxPercentage: e })) }} _label="% Arancelario" />
                                </div>
                            </>
                        }
                        {typeForm == importRegistry.instance.PRODUCTINVENTORY &&
                            <>
                                <div className="col-md-6">
                                    <label>No. Parte</label>
                                    <input type="text" name="SerialNumber" value={bean.SerialNumber} onChange={handleChange} className="form-control" />
                                </div>
                                <div className="col-md-6">
                                    <label>No. Documento</label>
                                    <input type="text" name="DocumentNumber" value={bean.DocumentNumber} onChange={handleChange} className="form-control" />
                                </div>
                                <div className="col-md-6">
                                    <label>Caso</label>
                                    <input type="text" name="Case" value={bean.Case} onChange={handleChange} className="form-control" />
                                </div>
                                <div className="col-md-6">
                                    <SelectTHConstantsValue returnType="Object" label="Unidad de Medida" value={bean.IDUnitProduct} code={10001} onChange={(e) => { setBean({ ...bean, IDUnitProduct: e.IDTHConstantsValue, UnitName: e.Name }) }} />
                                </div>
                            </>
                        }
                        {typeForm == importRegistry.instance.SETTLEMENT &&
                            <>
                                <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.VrFOB ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrFOB: e })) }} _label="Vr Unitario FOB" />
                                </div>
                                <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.VrDAP ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrDAP: e })) }} _label="Vr Unitario DAP" />
                                </div>
                                <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.VrGrabament ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrGrabament: e })) }} _label="Vr Grabamenes" />
                                </div>
                                {/* <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.VrFOB ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrFOB: e })) }} _label="Valor FOB" />
                                </div> */}

                            </>
                        }
                        {typeForm == importRegistry.instance.IMPORTDECLARATION &&
                            <>
                                <div className="col-md-6">
                                    <TaxPositionEditor render={bean.TaxCode}
                                        idSelector={bean.IDTaxPosition}
                                        onChange={(e) => { setBean(prev => ({ ...prev, IDTaxPosition: e.IDTaxPosition, TaxCode: e.TaxCode, TaxPercentage: e.TaxPercentage, TaxCodeStr: e.TaxCode + " - " + e.TaxDescription })) }}
                                        label="Posicion Arancelaria"
                                        returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <SelectTHConstantsValue returnType="Object" label="Unidad de Medida" value={bean.IDUnitProduct} code={10001} onChange={(e) => { setBean({ ...bean, IDUnitProduct: e.IDTHConstantsValue, UnitName: e.Name }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.VrFOB ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrFOB: e })) }} _label="Valor FOB" />
                                </div>
                                <div className="col-md-6">
                                    <InputMoney _style="decimal" _value={bean.VrFlete ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrFlete: e })) }} _label="Valor Flete" />
                                </div>
                            </>
                        }
                        {typeForm == importRegistry.instance.HANDOVERCERTIFICATE &&
                            <>
                                {formBean.DeliveryCertificateType === 101 ? <>
                                    <div className="col-md-6">
                                        <label>No. Parte</label>
                                        <input type="text" className="form-control" value={bean.ParteNo ?? ''} onChange={(e) => { setBean(prev => ({ ...prev, ParteNo: e.target.value })) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>No. Serie</label>
                                        <input type="text" className="form-control" value={bean.SerieNo ?? ''} onChange={(e) => { setBean(prev => ({ ...prev, SerieNo: e.target.value })) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputMoney _style="decimal" _value={bean.VrTotalFob ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrTotalFob: e })) }} _label="Valor FOB Total" />
                                    </div>
                                </> : <>
                                    <div className="col-md-6">
                                        <SelectTHConstantsValue returnType="Object" label="Unidad de Medida" value={bean.IDUnitProduct} code={10001} onChange={(e) => { setBean({ ...bean, IDUnitProduct: e.IDTHConstantsValue, UnitName: e.Name }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputMoney _style="decimal" _value={bean.VrUnitario ?? 0} onChange={(e) => { setBean(prev => ({ ...prev, VrUnitario: e })) }} _label="Valor Unitario" />
                                    </div>
                                </>}
                            </>
                        }
                    </div>
                </Modal>
                <Modal modal={modalImportar.modal} updateModal={modalImportar.setModal} evenOnClose={getListItems}>
                    <div className="row">
                        <div className="col-md-12">
                            <ImportRegistryItem editor={true} importRegistry={formBean} onChange={addItemFromList} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={delItem}>
                    <div className="row">
                        <div className="col-md-12">
                            Eliminar registro ?
                        </div>
                    </div>
                </ModalConfirm>
            </div>

        </div>
    )
}
